module.exports = __webpack_public_path__ + "img/document-attachment 1.fcf799d0.svg";